export const CODE_39 = 20;
export const ITF = 20;
export const CODE_128 = 28;
export const CODE_128_9 = 9;

export const CODE_39_SHORT = 11;
export const CODE_128_SHORT = 15;

export const deliveryBarcodesLengths = {
  CODE_39,
  CODE_128,
  ITF,
};
